import { Container } from '@chakra-ui/react';
import { GetServerSidePropsContext, NextPage } from 'next';
import { getSession } from 'next-auth/react';
import { useIntl } from 'react-intl';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import Article from '@/components/Article';
import ArticleContent from '@/components/Article/articleContent';
import { H1 } from '@/components/Heading';
import Seo from '@/components/Seo';

import { LocaleProps } from '@/models/props/LocalizationProps';
import { PrivacyPolicyService } from '@/services/PrivacyPolicyService';

type PrivacyPolicyProps = {
    content: Record<string, string>;
};

const PrivacyPolicyPage: NextPage<PrivacyPolicyProps> = (props: PrivacyPolicyProps) => {
    const intl = useIntl();
    const content = props.content;

    return (
        <>
            <Seo templateTitle={intl.formatMessage({ id: 'privacy-policy' })} />
            <Container maxW="container.2xl">
                <Article>
                    <H1 textAlign="center">{content.title}</H1>
                    <ArticleContent content={content.content} />
                </Article>
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    async (context: GetServerSidePropsContext) => {
        const session = await getSession(context);
        const { locale } = context;
        let content;

        try {
            if (session && session.user?.hasCredentials) {
                content = await PrivacyPolicyService.getPrivacyPolicyClub(locale as LocaleProps);
            } else {
                content = await PrivacyPolicyService.getPrivacyPolicyGuest(locale as LocaleProps);
            }
        } catch {
            content = [];
        }

        if (content.length === 0) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                content
            }
        };
    }
);

export default PrivacyPolicyPage;
